const configuredApiBaseUrl = String(process.env.REACT_APP_API_BASE_URL || "")
  .trim()
  .replace(/\/+$/, "");
const isLocalBrowser = ["localhost", "127.0.0.1"].includes(
  window.location.hostname
);
const configuredApiIsLocal =
  /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(configuredApiBaseUrl);
const runtimeApiBaseUrl = isLocalBrowser
  ? configuredApiBaseUrl || "http://localhost:5003"
  : configuredApiIsLocal || !configuredApiBaseUrl
    ? `${window.location.origin}/api`
    : configuredApiBaseUrl;

const config = {
  API_BASE_URL: runtimeApiBaseUrl,

  
  WORKER: {
    LOGIN: "/worker/login",
    REGISTER: "/worker/register",
    STATUS: "/worker/status",
    PROFILE: "/worker/profile",
    PROFILE_PHOTO: "/worker/profile-photo"
  }

 
};

export default config;
